import { TaskCenterQueries, TaskCenterTypesV2 } from '@frontend/api-task-center';
import { useTaskCenterStore } from '@frontend/task-center-scope';

interface UseGetTasksProps {
  status: TaskCenterTypesV2.SchemaTypes.Enums.TaskStatus;
  enabled?: boolean;
}

export const useGetTasksV2 = ({ status, enabled = true }: UseGetTasksProps) => {
  const { locationIds, selectedFilters, assigneeFilter } = useTaskCenterStore([
    'locationIds',
    'selectedFilters',
    'assigneeFilter',
  ]);

  const filters: TaskCenterTypesV2.SchemaTypes.ListTasksRequestV2['filters'] = {
    locationId: locationIds,
    status: [status],
  };

  const pagination: TaskCenterTypesV2.SchemaTypes.ListTasksRequestV2['pagination'] = {};

  if (selectedFilters.source) {
    filters['source'] = selectedFilters.source;
  }

  if (selectedFilters.createdBy) {
    filters['createdBy'] = selectedFilters.createdBy;
  }

  if (assigneeFilter) {
    filters['assignee'] = [assigneeFilter];
  }

  if (selectedFilters.sortType) {
    pagination['sortField'] = selectedFilters.sortType;
    pagination['sortType'] = TaskCenterTypesV2.SchemaTypes.Enums.SortType.SORT_ASC;
  }

  return TaskCenterQueries.useGetTasksListV2({ filters, pagination }, { enabled });
};
